module.exports = __webpack_public_path__ + "img/network-wireless-signal-good-symbolic.2a082838.svg";